// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"31882918","453":"3134ffda","455":"c578d697","977":"38a7e1f4"}[chunkId] + ".chunk.js";
};